import React from 'react'
import BaseIcon from 'react-icon-base'

const CN = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>CN</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <rect id="c" width="20" height="14" x=".5" y=".5" rx="1" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#CF2338" xlinkHref="#a" />
      <path
        fill="#FFD128"
        d="M2 5l3.077 1.846L4 10l2.5-2.333L9 10 7.923 6.846 11 5H2zm6 0H5l1.5-3L8 5z"
        mask="url(#b)"
      />
      <path fill="#F8B92A" d="M12 3v1h1V3h-1zm1 2v1h1V5h-1zm0 2v1h1V7h-1zm-1 2v1h1V9h-1z" mask="url(#b)" />
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#c" />
    </g>
  </BaseIcon>
)

export default CN
